import React from 'react';
import { Route, Switch } from 'react-router';
import asyncComponent from '../common/components/async-component';

const asyncFourOhTwo = asyncComponent(()=>import('../static/components/402.jsx'));
const asyncFourOhThree = asyncComponent(()=>import('../static/components/403.jsx'));
const asyncFourOhFour = asyncComponent(()=>import('../static/components/404.jsx'));
const asyncFiveHundred = asyncComponent(()=>import('../static/components/500.jsx'));

const ErrorRoutes = (props) => {
    return(
        <Switch>
            <Route exact path="/error/402" component={asyncFourOhTwo} {...props}/>
            <Route exact path="/error/403" component={asyncFourOhThree} {...props}/>
            <Route exact path="/error/404" component={asyncFourOhFour} {...props}/>
            <Route exact path="/error/500" component={asyncFiveHundred} {...props}/>
        </Switch>
    );
};

export default ErrorRoutes;


// WEBPACK FOOTER //
// ./src/routes/error-routes.jsx